import { useCallback, useState } from 'react';
import { useDebouncedResizeHandler } from './useDebouncedResizeHandler';
export function useDebouncedWindowSize() {
    const [dimensions, setDimensions] = useState({ w: window.innerWidth, h: window.innerHeight });
    const handleResize = useCallback(() => {
        setDimensions({ w: window.innerWidth, h: window.innerHeight });
    }, []);
    useDebouncedResizeHandler(handleResize);
    return { windowWidth: dimensions.w, windowHeight: dimensions.h };
}
